import type { PostHogConfig } from "posthog-js";

export const posthogConfig: Partial<PostHogConfig> = {
	api_host: process.env.PUBLIC_POSTHOG_HOST,
	capture_exceptions: true,
	capture_performance: true,
	capture_dead_clicks: false,
	capture_pageleave: true,
	disable_session_recording: true,
	enable_recording_console_log: true,
};
